/*eslint indent: ["error", 2, { "SwitchCase": 1 }]*/
import BootstrapTable from 'react-bootstrap-table-next'
import PropTypes from 'prop-types'
import React, {PureComponent} from 'react'
import RowsContext from '../RowsContext'
import paginationFactory from 'react-bootstrap-table2-paginator'
import produce from 'immer'
import { withRouter } from 'react-router-dom'
import {sizeFormatter} from '../../utils/fileSizeFunctions'

class S3FileListTable extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      files: [],
      selectedRows: [],
      dropDownValue: '5',
      clearSelectedRows: () => {
        this.setState(produce(draft => {
          draft.selectedRows = []
          draft.files = []
        }))
      }
    }

    // function binds
    this.handleOnSelect = this.handleOnSelect.bind(this)
    this.handleOnSelectAll = this.handleOnSelectAll.bind(this)

    this.histUnlisten = this.props.history.listen(() => {
      this.setState(produce((draft) => {
        draft.selectedRows = []
        draft.files = []
      }))
    })
  }

  handleOnSelect(row, isSelect) {
    if (isSelect) {
      this.setState(produce((draft) => {
        draft.selectedRows.push(row)
        draft.files.push(row.Key)
      }))
    } else {
      this.setState(produce((draft) => {
        draft.selectedRows = draft.selectedRows.filter(x => x.Key !== row.Key)
        draft.files = draft.files.filter(x => x !== row.Key)
      }))
    }
  }

  handleOnSelectAll(isSelect, rows) {
    const files = rows.map(r => r.Key)
    if (isSelect && files) {
      this.setState(produce((draft) => {
        draft.selectedRows = rows
        draft.files = files
      }))
    } else {
      this.setState(produce((draft) => {
        draft.selectedRows = []
        draft.files = []
      }))
    }
  }

  componentWillUnmount() {
    this.histUnlisten()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    let files = []
    if (prevProps.childItems === this.props.childItems) {
      files = this.state.files
    } else {
      this.setState(produce((draft) => {
        draft.selectedRows = []
        draft.files = []
      }))
    }
    this.props.setS3Filelists(files)
  }

  render() {
    const columns = [
      { dataField: 'Key', text: 'File Name',
        headerStyle: (column, colIndex) => { return { width:'70%', textAlign:'center'} },
        sort: true },
      { dataField: 'Size', text: 'File Size', formatter: sizeFormatter,
        headerStyle: (column, colIndex) => { return { width:'10%', textAlign:'center'} },
        sort: true }
    ]

    const getNonSelectableRows = (rows) => {
      let nonSelectedRows = []
      rows.forEach((row) => {
        //Disallow selection of subfolder
        if (row.Key && row.Key.includes('/')) nonSelectedRows.push(row.Key)
        //Disallow selection of glacier and glacier deep archive files
        if (row.StorageClass && (row.StorageClass == 'DEEP_ARCHIVE' || row.StorageClass == 'GLACIER'))
          nonSelectedRows.push(row.Key)
      })
      return nonSelectedRows
    }

    const selectRowProp = {
      mode: 'checkbox',
      clickToSelect: true,
      nonSelectable: getNonSelectableRows(this.props.childItems || []),
      nonSelectableStyle: { backgroundColor: 'gray' },
      selected: this.state.selectedRows.map(row => row.Key),
      onSelect: this.handleOnSelect,
      onSelectAll: this.handleOnSelectAll,
    }

    /*
    const rowStyle = (row, rowIndex) => {
      return row.Size !== row.TargetFileSize ? { backgroundColor: 'grey' }: { backgroundColor: 'white' }
    } */

    const paginationOpts = {
      page: 1,
      sizePerPage: 5,
      nextPageText: '>',
      prePageText: '<',
      showTotal: true,
      sizePerPageList: [{
        text: '5', value: 5
      }, {
        text: '10', value: 10
      }, {
        text: '20', value: 20
      }, {
        text: 'All', value: this.props.childItems.length
      }]
    }

    return (
      <RowsContext.Provider value={this.state}>
        <div className="sb-table-listing">
          <BootstrapTable
            responsive
            wrapperClasses="table-responsive"
            keyField='Key'
            data={this.props.childItems || []}
            columns={columns}
            bordered={false}
            selectRow={selectRowProp}
            pagination={paginationFactory(paginationOpts)}
            // rowStyle={rowStyle}
            noDataIndication="No Files Available"
          />
        </div>
      </RowsContext.Provider>
    )
  }
}

S3FileListTable.propTypes = {
  setS3Filelists: PropTypes.any,
  id: PropTypes.string,
  childItems: PropTypes.array,
  // The react specific route context
  parentId: PropTypes.string,
  // An optional prefix to prepend to the path when sending to the server
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }),
  history: PropTypes.shape({
    listen: PropTypes.func,
    push: PropTypes.func,
  })
}

export default withRouter(S3FileListTable)
